export const root = 'lapidary-avatar'

export const selectors = { root } as const
export const cssVariables = { size: `--${root}-size` } as const
export const parts = { image: 'image', text: 'text' } as const
